// @flow

import ko from 'rgs-knockout';
import _ from 'lodash';
import moment from 'moment';

import type { Error } from 'error';

import TraceKit from 'tracekit';

import googleTagManager from 'google-tag-manager';

import TraceKitContextSubscriber from './subscriber';

import { StepsMutex as Steps, StepsGrouped } from 'steps';
import * as observableServerTime from 'observable-server-time';

export type GoogleAnalyticsOnErrorOptions = {
	steps: Steps | StepsGrouped,
	productType?: Observable<string> | string,
	caseID: Observable<string> | string,
}

const STACKTRACE_LOG_DEEPNESS = 5;

export default class GoogleAnalyticsOnErrorSubscriber extends TraceKitContextSubscriber {

	constructor (options?: GoogleAnalyticsOnErrorOptions) {
		options = options || {};
		super();

		this.steps = options.steps;
		this.productType = options.productType;
		this.caseID = options.caseID;
	}

	onError (ctx: Object, error: Error) {
		const { handled } = error;

		if (handled && handled.type !== 'notification') {
			return;
		}

		if (ctx._special_.isOuterScriptError && !TraceKit.exposeOuterScriptErrors) {
			return;
		}

		const getCurrentStep = this.steps && (this.steps.getCurrent || this.steps.getCurrentGroup);

		const errorTimeMoment = observableServerTime.ready().inspect().state === 'fulfilled'
			? observableServerTime.serverTime()
			: moment();
		const errorTime = errorTimeMoment.format('HH:mm:ss [(][UTC]Z[)]');

		const errorDescription = {
			runtimeID: ctx._special_ && ctx._special_.id,
			quotationCaseID: ko.unwrap(this.caseID) || null,
			message: error.message,
			time: errorTime,
			stackTraceTop: _.map(
				_.take(ctx['TraceKit.Generic.Report'].stack, STACKTRACE_LOG_DEEPNESS),
				// eslint-disable-next-line max-len
				node => `at ${node.url} (func: ${node.func}): line ${node.line}, column ${node.column}`
			).join(', '),
		};

		const eventData = {
			event: 'addEvents',
			eventCategory: ko.unwrap(this.productType),
			// eslint-disable-next-line max-len
			eventAction: getCurrentStep ? `step_${getCurrentStep.call(this.steps).id}` : 'unknown step',
			eventLabel: 'error',
			errorDescription: JSON.stringify(errorDescription),
			nonInteraction: false,
		};

		googleTagManager
			.pusher()
			.extend(eventData)
			.push();
	}
}
